import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "mid-container"
};
const _hoisted_2 = {
  class: "lucky-wheel-bgc"
};
const _hoisted_3 = {
  key: 0,
  class: "time-count-down"
};
const _hoisted_4 = {
  key: 0,
  class: "block"
};
const _hoisted_5 = {
  key: 1,
  class: "block"
};
const _hoisted_6 = {
  class: "block"
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  class: "block"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "block"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 2,
  class: "reward-num"
};
const _hoisted_13 = {
  key: 3,
  class: "reward-num reward-num-sec"
};
const _hoisted_14 = {
  class: "lottery-mid-container"
};
const _hoisted_15 = {
  class: "lottery-btn-text"
};
const _hoisted_16 = {
  key: 0,
  class: "is-point"
};
const _hoisted_17 = {
  key: 4,
  class: "need-price"
};
const _hoisted_18 = {
  class: "reward-container"
};
const _hoisted_19 = {
  key: 0,
  class: "reward-img"
};
const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 1,
  class: "reward-name"
};
const _hoisted_22 = {
  key: 2,
  class: "reward-name-sec"
};
const _hoisted_23 = {
  class: "reward-btn-list"
};
const _hoisted_24 = {
  class: "ruler-bgc-dialog"
};
const _hoisted_25 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_lucky_wheel = _resolveComponent("lucky-wheel");
  const _component_van_count_down = _resolveComponent("van-count-down");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_dialog = _resolveComponent("van-dialog");
  return _openBlock(), _createElementBlock("div", {
    class: "roll-bgc",
    style: _normalizeStyle(_ctx.backgroundStyle)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "popup"
  }, null, -1)), _createVNode(_component_lucky_wheel, {
    ref: "myLucky",
    blocks: _ctx.blocks,
    prizes: _ctx.prizes,
    buttons: _ctx.buttons,
    defaultConfig: _ctx.defaultConfig,
    onStart: _ctx.startCallback,
    onEnd: _ctx.endCallback,
    width: "270px",
    height: "270px"
  }, null, 8, ["blocks", "prizes", "buttons", "defaultConfig", "onStart", "onEnd"])])]), _ctx.lotteryList.type == 2 && _ctx.time > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_van_count_down, {
    time: _ctx.time,
    millisecond: ""
  }, {
    default: _withCtx(timeData => [timeData.days > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(timeData.days), 1)) : _createCommentVNode("", true), timeData.days > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5, "天")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_6, [timeData.hours < 10 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "0")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(timeData.hours), 1)]), _cache[11] || (_cache[11] = _createElementVNode("span", {
      class: "colon"
    }, ":", -1)), _createElementVNode("span", _hoisted_8, [timeData.minutes < 10 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "0")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(timeData.minutes), 1)]), _cache[12] || (_cache[12] = _createElementVNode("span", {
      class: "colon"
    }, ":", -1)), _createElementVNode("span", _hoisted_10, [timeData.seconds < 10 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "0")) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(timeData.seconds), 1)])]),
    _: 1
  }, 8, ["time"])])) : _createCommentVNode("", true), _ctx.lotteryList.type == 2 && _ctx.time <= 0 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "time-count-down",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.realityPrize())
  }, _cache[13] || (_cache[13] = [_createElementVNode("div", {
    class: "block-over"
  }, "活动已结束，请尽快填写地址～", -1)]))) : _createCommentVNode("", true), _ctx.lotteryList && _ctx.lotteryList.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_12, " 活动期间剩余抽奖次数：" + _toDisplayString(_ctx.lotteryList.remain_num || 0), 1)) : _createCommentVNode("", true), _ctx.lotteryList && _ctx.lotteryList.type != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 今日剩余抽奖次数：" + _toDisplayString(_ctx.lotteryList.remain_num || 0), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "ruler-icon",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.rulerShow())
  }, [_ctx.lotteryList.type == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "address-icon",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.realityPrize(), ["stop"]))
  })) : _createCommentVNode("", true)]), _createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => _ctx.startCallback && _ctx.startCallback(...args)),
    class: "lottery-btn"
  }, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.lotteryList.type == 2 ? 'top-margin' : ''])
  }, " 开始抽奖 ", 2), _ctx.lotteryList.type != 2 ? (_openBlock(), _createElementBlock("div", _hoisted_16, " (" + _toDisplayString(_ctx.lotteryList.price) + "积分) ", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", {
    class: "record-icon",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.goExchangeRecord())
  })]), _ctx.lotteryList.type == 2 && _ctx.lotteryList.again_price > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_cache[14] || (_cache[14] = _createTextVNode(" 再充值")), _createElementVNode("span", null, _toDisplayString(_ctx.lotteryList.again_price), 1), _cache[15] || (_cache[15] = _createTextVNode("元，获取一次抽奖机会 "))])) : _createCommentVNode("", true), _createVNode(_component_van_popup, {
    show: _ctx.showLotteryResult,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => _ctx.showLotteryResult = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_ctx.lotteryDetail.reward ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("img", {
      src: _ctx.lotteryDetail.reward.image_url,
      alt: ""
    }, null, 8, _hoisted_20)])) : _createCommentVNode("", true), _ctx.lotteryDetail.reward ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.lotteryDetail.reward.name), 1)) : _createCommentVNode("", true), _ctx.lotteryDetail.reward && _ctx.lotteryList.type == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.lotteryDetail.reward.describe), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [_ctx.lotteryDetail.reward.type == 2 ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "reward-btn",
      onClick: _cache[5] || (_cache[5] = $event => _ctx.realityPrize())
    }, " 填写地址 ")) : _createCommentVNode("", true), _ctx.lotteryDetail.reward.type == 4 ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "reward-btn",
      onClick: _cache[6] || (_cache[6] = $event => _ctx.getRewardCode())
    }, " 获取兑换码 ")) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "reward-btn",
      onClick: _cache[7] || (_cache[7] = $event => _ctx.showLotteryResult = false)
    }, " 继续抽奖 ")]), _cache[16] || (_cache[16] = _createElementVNode("div", null, null, -1))])]),
    _: 1
  }, 8, ["show"]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_van_dialog, {
    show: _ctx.rulerPopup,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => _ctx.rulerPopup = $event),
    title: "活动规则"
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "ruler-bgc",
      innerHTML: _ctx.lotteryList.describe
    }, null, 8, _hoisted_25)]),
    _: 1
  }, 8, ["show"])])], 4);
}